import {
  Autocomplete,
  Box,
  Button,
  FormHelperText,
  InputLabel,
  SxProps,
  TextField,
  Typography,
} from "@mui/material";
import { isTruthy } from "helpers/methods";
import CustomAutoCompleteStyles from "global/components/CustomAutoComplete/CustomAutoComplete.styles";

export interface CustomProps {
  label: string;
  options: any;
  sx?: SxProps;
  id: string;
  placeHolder?: string;
  onChange: Function;
  onChangeForTextField?: Function;
  error?: string;
  value: any;
  disabled?: boolean;
  name?: string;
  loading?: boolean;
  clearIcon?: boolean;
  filterOptions?: any;
  type?: string;
  inputValue?: string;
  multiple?: boolean;
  groupBy?: (option: any) => string;
  getOptionLabel?: (option: any) => string;
  renderTags?: (value: string[], getTagProps: any) => React.ReactNode;
  renderOption?: (props: any, option: any, state: any) => React.ReactNode;
  freeSolo?: boolean;
  addBtnComponentClick?: any;
  addBtnTitle?: string;
}

const CustomAutoCompleteNew = (props: CustomProps) => {
  const classes = CustomAutoCompleteStyles;

  const ListboxComponent = (listboxProps: any) => {
    const { children, ...other } = listboxProps;

    return (
      <ul {...other}>
        {props.addBtnComponentClick && (
          <li>
            <Button
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                props.addBtnComponentClick();
              }}
              fullWidth
              sx={{
                justifyContent: "flex-start",
                textTransform: "none",
                p: 1.5,
                color: "primary.main",
                "&:hover": {
                  backgroundColor: "action.hover",
                },
              }}
            >
              <Typography variant="body1" fontWeight={600}>
                {props.addBtnTitle ? props.addBtnTitle : "Add New"}
              </Typography>
            </Button>
          </li>
        )}
        {children}
      </ul>
    );
  };

  const noOptionsText = () => {
    if (props.addBtnComponentClick) {
      return (
        <Button
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            props.addBtnComponentClick();
          }}
          sx={{
            textTransform: "none",
            p: "0px !important",
            color: "primary.main",
          }}
        >
          <Typography variant="body1" fontWeight={600}>
            {props.addBtnTitle || "Add New"}
          </Typography>
        </Button>
      );
    }
    return "No options";
  };

  return (
    <Box>
      <Box mb={1}>
        <InputLabel id="stateId" required>
          {props.label}
        </InputLabel>
      </Box>
      <Autocomplete
        multiple={props.multiple}
        id={props.id}
        freeSolo={props.freeSolo}
        componentName={props.name}
        inputValue={props.inputValue}
        loading={props?.loading}
        sx={props.sx ? props.sx : classes.autoComplete}
        value={props.value}
        clearIcon={props.clearIcon}
        options={props.options}
        disabled={props.disabled}
        filterOptions={props.filterOptions}
        onChange={(event: any, newValue: any, index: any) =>
          props.onChange(event, newValue, index)
        }
        fullWidth
        ListboxComponent={
          props.addBtnComponentClick ? ListboxComponent : undefined
        }
        noOptionsText={noOptionsText()}
        renderInput={(params: any) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={props.placeHolder}
            error={isTruthy(props.error)}
            fullWidth
            onChange={(event: any) =>
              props.onChangeForTextField && props.onChangeForTextField(event)
            }
            onKeyDown={(event: any) => {
              if (
                event.key === "Backspace" ||
                event.key === "Delete" ||
                event.key === "ArrowLeft"
              ) {
                event.stopPropagation();
              }
            }}
            InputProps={{
              ...params.InputProps,
              sx: {
                "& .MuiOutlinedInput-input": {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "270px",
                },
              },
              title: props.value || "",
            }}
          />
        )}
        getOptionLabel={props.getOptionLabel}
        groupBy={props.groupBy}
        renderTags={props.renderTags}
        renderOption={props.renderOption}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
      />
      {props.error && (
        <FormHelperText error sx={{ paddingLeft: "14px" }}>
          {props.error}
        </FormHelperText>
      )}
    </Box>
  );
};

export default CustomAutoCompleteNew;
